import React from 'react';

class Simple extends React.Component {

    render() {
        // const title = window.HEADER_TITLE || ''
        return (
            <header id="header-mini">
                <div className="header-mini_body">
                    <h1 className="tit-h1">
                        <a href={process.env.REACT_APP_WWW_URL}>
                            <img src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/logo_happyshopping.png`} alt="행복쇼핑" />
                        </a>
                    </h1>
                </div>
            </header>
        )
    }
}
export default Simple;



// WEBPACK FOOTER //
// ./src/header/component/simple.js